import React, { useEffect } from 'react';
import SkillCard from './card/SkillCard';
import { portfolioData } from '../../../data/portfolio';

const About = props => {
    const { about } = portfolioData;

    useEffect(() => {
        // Load LinkedIn badge script dynamically
        const loadLinkedInBadge = () => {
            const existingScript = document.querySelector('script[src*="platform.linkedin.com"]');
            if (existingScript) existingScript.remove();

            const script = document.createElement('script');
            script.src = 'https://platform.linkedin.com/badges/js/profile.js';
            script.async = true;
            script.defer = true;
            script.type = 'text/javascript';

            document.head.appendChild(script);

            script.onload = () => {
                setTimeout(() => {
                    if (window.LI && window.LI.createProfile) {
                        window.LI.createProfile();
                    }
                }, 500);
            };
        };

        loadLinkedInBadge();
    }, []);

    return (
        <div className="w-full px-6 md:px-12 py-6" id="about">
            <div className="w-full mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    {/* Main Content */}
                    <div className="lg:col-span-7">
                        {/* Section Header */}
                        <div className="mb-6 relative pl-4 border-l-4 border-primary-500">
                            <h4 className="text-sm font-bold tracking-widest text-primary-600 uppercase mb-2 font-sans">Wait, Who am I?</h4>
                            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-display">About Me</h1>
                        </div>

                        <div className="prose prose-lg text-gray-600 space-y-6 leading-relaxed">
                            <p className="text-xl font-light text-gray-800">
                                Hi, I'm <strong className="font-semibold text-primary-600">{about.name}</strong>, a dedicated <strong className="text-gray-900">{about.role}</strong> with over <strong className="text-gray-900">{about.experienceYear}</strong> of experience in building scalable web applications.
                            </p>
                            <p>
                                Currently, I am a <strong>{about.currentRole}</strong> at <strong>{about.currentCompany}</strong>, creating innovative solutions for top-tier digital marketing clients. My journey began with a <strong>{about.education.degree}</strong> from <strong>{about.education.university}</strong>, fueling my passion for software engineering.
                            </p>
                            <p>
                                {about.bio[2]}
                            </p>
                            <div className="bg-blue-50/50 p-6 rounded-2xl border border-blue-100 my-8">
                                <p className="mb-0 italic text-blue-900">
                                    "{about.bio[3]}"
                                </p>
                            </div>
                            <p>
                                {about.bio[4]}
                            </p>

                            <a href="#contact" className="inline-flex items-center text-primary-600 font-semibold hover:text-primary-700 transition-colors mt-4 group">
                                Let's build something together
                                <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                            </a>
                        </div>
                    </div>

                    {/* Sidebar: Skills & Social */}
                    <div className="lg:col-span-5 space-y-8">
                        <SkillCard />

                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
